// /notifications — full-page Notifications V2 (same inbox as the bell, wider).
import Layout from "../components/Layout";
import InboxV2 from "../components/notifications/InboxV2";

export default function NotificationsPage() {
  return (
    <Layout>
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-6" data-testid="notifications-page">
        <h1 className="text-2xl font-bold text-white mb-1">Notifications</h1>
        <p className="text-[13px] text-slate-400 mb-4">Clear and act on work — every action writes to the real task or quote and can be undone.</p>
        <div className="rounded-2xl border border-white/10 bg-[#0F1A30] overflow-hidden h-[calc(100vh-190px)]">
          <InboxV2 mode="page" />
        </div>
      </div>
    </Layout>
  );
}
